export const rewardsEndpointPath = '/api/v1/rewards'
export const selectedRewardEndpointPath = '/api/v1/profile/selected-reward'
export const rewardsRecommendationsEndpointPath = '/api/v1/rewards/recommendations'
export const redemptionsEndpointPath = '/api/v2/redemptions'
